import { Component, OnInit, ViewEncapsulation, AfterViewChecked } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { Router, ActivatedRoute } from '@angular/router';
import { StepIndicatorModel, StepIndicatorService, AccordionModel, ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel, FilterService } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { SignupService } from './../shared/providers/signup.service';
import { SignUpModel, SignUpInputModel, SignUpOutputModel, ProfileModel, SettingsModel , FanModel} from './../shared/models/signup.models';
import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { SIGNUPDATA } from 'config';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  providers: [SignupService, AdobeAnalyticsService],
  styleUrls: ['./review.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SetupReviewComponent implements OnInit, AfterViewChecked {
  signupInputData: SignUpInputModel;
  signupOutputData: SignUpOutputModel;
  public enrollDatePopup: ConfirmModalPopupModel;
  acknowledged: boolean;
  initialSignup: boolean;
  is_acknowledged: boolean;
  selectedApps: Array<string>;
  selectedFan: string;
  showError: boolean;
  errorMessage: string;
  errorMessageDesc: string;
  reviewData: any;
  accordion: boolean;
  gridOptions: GridOptionsModel;
  tabArray: Array<any>;
  authenticatepage: boolean;
  pageContent: any;
  settingsConfig: any;
  displayFANText: string;
  existingDateNull: boolean;
  changeEnrollmentSettings: boolean;
  public pageDescription: Array<any>;
  private activeFANList: Array<FanModel> = [];
  private futureEnrollList: Array<FanModel> = [];
  emmProductCode: any;
  oemStatus: boolean;
  showSupportModal: boolean;
  eventEmit: any;
  checkboxDisable = true;
  OemHeading: any;
  selectedAccID: any;
  selectedSamsungID: any;
  selectedGoogleID: any;
  user: any;
  agreementID: any;
  fanArrayList: any = [];
  reviewDataList: any;
  notificationTypeList: any = [];
  createProfileJson: any = {};
  manageProduct: any;
  initialSignupStaus: boolean;
  signupStatus: any;
  createZTPStaus: boolean;
  productDetails: any;
  showEnrollDetailsModal = false;


  constructor(private route: ActivatedRoute, private router: Router,
    private activatedRoute: ActivatedRoute,
    private stepindicatorService: StepIndicatorService,
    private utilityService: UtilityService,
    private pageloaderService: PageLoaderService,
    private signupService: SignupService,
    private adobeAnalyticsService: AdobeAnalyticsService) {
    this.existingDateNull = false;
    let revisedFanList;
    //this.pageloaderService.setPageLoaderStatus(false);
    const signupData = this.signupService.getSignupModel();
    if (signupData) {
      this.signupInputData = signupData.inputModel;
      this.signupOutputData = signupData.outputModel;
      this.initialSignup = signupData.initialSignup;
      revisedFanList = this.signupOutputData.FANList.revisedFanList;
      this.authenticatepage = true;
    } else {
      this.authenticatepage = false;
      this.router.navigate(['/signup/accounts']);
    }
    if (revisedFanList) {
      console.log(revisedFanList);
      revisedFanList.forEach(fan => {
        if (fan.accountSubStatus === 'Active') {
          this.activeFANList.push(fan);
        } else {
          this.futureEnrollList.push(fan);
        }
      });
    }
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];

    if (!this.authenticatepage) {
      return;
    }

    //this.signupService.pageContent(this.utilityService.getEnvConfig().contentUrl.signup.review).
    //subscribe(respobj => {
    //  this.pageContent = respobj;
    //  this.pageloaderService.setPageLoaderStatus(true);
    //});

    this.pageContent = this.route.snapshot.data.pageData.signupreview;

    // this.emmProductCode = sessionStorage.getItem('emmProductCode');
    // this.selectedAccID = sessionStorage.getItem('selectedAccID');
    this.manageProduct = JSON.parse(sessionStorage.getItem('manage-product'));
    this.emmProductCode = this.manageProduct.emmProductCode;
    this.selectedAccID = this.manageProduct.selectedAccID;
    this.signupStatus = this.manageProduct.signupEmmStatus;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.agreementID = this.user.user.agreement.id;
    this.createZTPStaus = false;
    if (this.emmProductCode === 'DMPSKME' || this.emmProductCode === 'DMPGZTP') {
      this.oemStatus = true;
    } else {
      this.oemStatus = false;
    }
    if (this.emmProductCode === 'DMPGZTP') {
      this.OemHeading = this.pageContent.MDMService.productZTP;
      this.selectedGoogleID = this.selectedAccID;
      this.initialSignupStaus = true;
    } else if (this.emmProductCode === 'DMPSKME') {
      this.OemHeading = this.pageContent.MDMService.productKME;
      this.selectedSamsungID = this.selectedAccID;
      this.initialSignupStaus = true;
    } else {
      this.OemHeading = this.pageContent.MDMService.productIBM;
      if (this.emmProductCode === 'ADDPMDM' && this.signupStatus === 'revised') {
        this.initialSignupStaus = false;
      } else {
        this.initialSignupStaus = true;
      }
    }

    this.eventEmit = document.activeElement;
    this.enrollDatePopup = new ConfirmModalPopupModel();
    this.enrollDatePopup.modalHeader = this.pageContent.enrollDatePopup.heading;
    // tslint:disable-next-line:max-line-length
    if(!this.oemStatus) {
      this.enrollDatePopup.modalMessage = this.pageContent.enrollDatePopup.description;
    }
    else {
      this.enrollDatePopup.modalMessage = this.pageContent.enrollDatePopup.descriptionOem;
    }
    this.enrollDatePopup.showCancelButton = false;
    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.stepindicatorService.setVisibility(true);
    this.reviewData = SIGNUPDATA.ReviewPage;
    this.settingsConfig = SIGNUPDATA.SettingsPage;
    this.is_acknowledged = false;
    this.selectedApps = this.signupService.selectedAppList(this.signupInputData.appList,
      this.signupOutputData.profile.applications);

    this.selectedFan = this.signupService.getSelectedFAN(this.signupOutputData.FANList);
    this.displayFANText = this.signupOutputData.FANList[this.selectedFan].length === 1 ? 'foundation account selected'
    : 'foundation accounts selected';
    this.pageDescription = [{
      'header': 'Accounts with enrolled devices',
      'accordion': [this.createAccordionModel('ActiveFAN',
      'hi')],
      'hide': !this.activeFANList.length,
      'gridHeader': (this.activeFANList.length === 1) ? this.activeFANList.length + '&ensp; ' +
      'Account with deployed devices' : this.activeFANList.length + '&ensp; ' + 'Accounts with deployed devices',
      'gridOptions': this.createGridOptions('active'),
      'moreThanFiveFan': this.activeFANList.length > 5,
      'gridCallback': this.updateActiveList
    }, {
      'header': 'Accounts with pending devices',
      'accordion': [this.createAccordionModel('FutureFAN',
         'hi')],
      'hide': !this.futureEnrollList.length,
      'gridHeader': (this.futureEnrollList.length === 1) ? this.futureEnrollList.length +  '&ensp; '
      + 'Account with devices not yet enrolled' : this.futureEnrollList.length +  '&ensp; ' + 'Accounts with devices not yet enrolled',
      'gridOptions': this.createGridOptions('future'),
      'moreThanFiveFan': this.futureEnrollList.length > 5,
      'gridCallback': this.updateFutureList
  }];

    if (this.futureEnrollList.length > 0 || this.activeFANList.length > 0) {
      this.changeEnrollmentSettings = true;
    }else {
      this.changeEnrollmentSettings = false;
    }

    this.accordion = this.signupOutputData.FANList[this.selectedFan].length > 5;
    if (this.accordion) {
      this.tabArray = [{
        id: 1, isActive: false,
        category: (this.signupOutputData.FANList[this.selectedFan].length === 1)
        ? this.signupOutputData.FANList[this.selectedFan].length + ' foundation account selected' :
        this.signupOutputData.FANList[this.selectedFan].length + ' foundation accounts selected', content: '',
        ariaLabel: {
          'expand': 'Show foundation accounts.',
          'collapse': 'Hide foundation accounts.'
        }
      }];
    }

    this.gridOptions = this.signupService.initSelectedFanGrid(this.signupOutputData.FANList[this.selectedFan].slice(),
      this.reviewData.columnDefinitions, this.accordion);


      if (this.signupOutputData.deviceEnrollDate.existing == null) {
      this.existingDateNull = true;
      }
       this.signupService.createPageLoadProperties('REVIEW', 'Review');
  }

  createAccordionModel(id: string, ariaLabel) {
    const accordionModel = new AccordionModel();
    const fanList = (id === 'ActiveFAN') ? this.activeFANList : this.futureEnrollList;
    accordionModel.id = id;
    accordionModel.isActive = false;
    accordionModel.category = (id === 'ActiveFAN') ? (this.activeFANList.length + '&ensp; ' + 'Account with deployed devices')
      : (this.futureEnrollList.length + '&ensp; ' + '  Accounts with devices not yet enrolled');
    accordionModel.ariaLabel = ariaLabel;
    return accordionModel;
  }

  createGridOptions(id: string) {
    const gridOption = new GridOptionsModel();
    const columns: ColumnDefinitionsModel = {
      field: 'fanId',
      caption: 'Foundation accounts',
      type: 'TEXT'
    };

    const pages: PaginationsModel = {
      recordsPerPage: 20,
      currentPage: 1,
      totalRecords: id === 'active' ? this.activeFANList.length : this.futureEnrollList.length,
      isServerSide: false,
    };
    gridOption.ariaLabel= "Select all foundation account numbers";
    gridOption.enableFiltering = false;
    gridOption.columnDefinitions = [columns];
    gridOption.enableSorting = false;
    gridOption.gridData = id === 'active' ? this.activeFANList : this.futureEnrollList;
    gridOption.Paginations = pages;
    gridOption.searchPlaceHolder = '';
    gridOption.searchDescriptions = '';
    gridOption.callbacks = null;
    gridOption.multiSelect = false;
    gridOption.disableGrid = false;
    gridOption.disableRow = false;
    gridOption.disableRowCondition = { field: '', value: '' };
    return gridOption;

  }
  updateFutureList = ($event: any) => {
    this.futureEnrollList = $event.griddata;
    const title = (this.filterSelected(this.futureEnrollList).length === 1) ?
    this.filterSelected(this.futureEnrollList).length + ' Foundation Account Selected' :
    this.filterSelected(this.futureEnrollList).length + ' Foundation Accounts Selected';
    this.updateView(this.pageDescription[1], title);
  }

  updateActiveList = ($event: any) => {
    this.activeFANList = $event.griddata;
    const title = (this.filterSelected(this.activeFANList).length === 1) ?
    this.filterSelected(this.activeFANList).length + ' Foundation Account Selected' :
    this.filterSelected(this.activeFANList).length + ' Foundation Accounts Selected';
    this.updateView(this.pageDescription[0], title);
  }

  updateView(description: any, title: string) {
    if (description.accordion) {
      description.accordion[0].category = title;
    } else {
      description.gridHeader = title;
    }
    if(this.is_acknowledged){
      this.showError = false;
    }
  }

  filterSelected(fanList: Array<any>) {
    const filteredFans = new Array();
    fanList.forEach(fan => {
      if (fan.selected) {
        filteredFans.push(fan);
      }
    });
    return filteredFans;
  }

  onRowClick(action) {
    this.signupOutputData.FANList[this.selectedFan] = action.griddata.filter(item => item.selected === true);
  }

  backToPrevious(event, tab) {
    event.preventDefault();
    this.router.navigate(['/signup/' + tab]);
  }
  backToProductSelection(event, tab) {
    event.preventDefault();
    this.router.navigate(['/productselection/']);
  }

  showenroll() {
    this.showEnrollDetailsModal = true;
  }
  closeModal(confirm) {
    this.showEnrollDetailsModal = false;

  }
  ngAfterViewChecked() {
    if (this.showError && !document.getElementById('alertMessage').classList.contains('msgShown')) {
      document.getElementById('alertMessage').scrollIntoView();
      document.getElementById('alertMessage').classList.add('msgShown');
    }
  }

  confirmAndSubmit() {
    for (let i = 0; i < this.signupOutputData.FANList[this.selectedFan].length; i++) {
      this.fanArrayList.push(this.signupOutputData.FANList[this.selectedFan][i].fanId);
    }
    if (this.activeFANList.length || this.futureEnrollList.length) {
      this.signupOutputData.FANList.revisedFanList = this.filterSelected(this.activeFANList.concat(this.futureEnrollList));
      if (!this.signupOutputData.FANList.revisedFanList.length) {
        this.showError = true;
        this.errorMessage = this.pageContent.errorMessage.noFanSelected;
        return;
      }
    }
    this.reviewDataList = JSON.parse(sessionStorage.getItem('user'));
    this.notificationTypeList = [];
    if (this.signupOutputData.profile.settings.emailEnabled === true && this.signupOutputData.profile.settings.smsEnabled === false) {
      this.notificationTypeList.push('email');
    }else if (this.signupOutputData.profile.settings.emailEnabled === false && this.signupOutputData.profile.settings.smsEnabled === true) {
      this.notificationTypeList.push('sms');
    }else if (this.signupOutputData.profile.settings.emailEnabled === false &&
      this.signupOutputData.profile.settings.smsEnabled === false) {
      this.notificationTypeList.push('email', 'sms');
    }else {
      this.notificationTypeList.push();
    }
    this.createProfileJson = {
      'notificationType': this.notificationTypeList,
      'agreementID': this.reviewDataList.user.agreement.id,
      'tcmFirstName': this.reviewDataList.user.firstName,
      'tcmLastName': this.reviewDataList.user.lastName,
      'tcmUser': this.reviewDataList.user.userId,
      'tcmEmailAddress': this.reviewDataList.user.emailAddress,
      'contactNo': this.reviewDataList.user.contactPhoneNumber,
      'emmProductCode': this.emmProductCode,
      'productName': this.OemHeading,
      'oceOrderId': 'CRX_1256',
      'status': 'Active',
      'transactionType': 'credit',
      'fan_list': this.fanArrayList,
      'signUpSource': 'email'

    };
    this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formSubmit',
    'BC_Device_Signup_Review_Submit', 'success msg', 'Success_Admit', 'Submit', 'Body', '/businessconsole/signup/confirm');
    const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
    const isDisabled = impersonator && impersonator.id ? true : false;
    if (!this.signupOutputData.FANList[this.selectedFan].length) {
      this.showError = true;
      this.errorMessage = this.pageContent.errorMessage.noFanSelected;
    } else if (!this.is_acknowledged) {
      this.showError = true;
      this.errorMessage = this.pageContent.errorMessage.acknowledge;
    } else if (isDisabled) {
      (<HTMLInputElement>document.getElementById('review-btn')).disabled = true;
    } else {
      this.showError = false;
      this.pageloaderService.setPageLoaderStatus(false);
      /* Api to create/update profile*/
      const isNewProfile = this.signupOutputData.profile.defaultProfile || this.signupService.compareTwoObject(
        this.signupInputData.profileList.filter(item => item.profileName === this.signupOutputData.profile.profileName)[0],
        this.signupOutputData.profile) > 0;
        if (!this.utilityService.getEnvConfig().useMock) {

        if (isNewProfile) {
          this.signupOutputData.profile.profileName = 'Profile-' + this.signupService.getAutogeneratedProfileName();
        }
            this.signupService.createProfile(this.signupService.getSetupDataFromModel(this.signupOutputData, isNewProfile,
              this.selectedFan === 'revisedFanList'))
              .subscribe(resobj => {
                this.signupOutputData.profile.profileId = resobj.profileId;
                this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup, isNewProfile);
                // Adobe Analytics Starts
            this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formResponse',
            'BC_Device_Signup_Review_Submit', 'success', 'Success_Admit', 'Submit', 'Body', '/businessconsole/signup/confirm');
                // Ends
                this.router.navigate(['/signup/confirm']);
              }, (error) => {
                this.showError = true;
                this.errorMessage = this.pageContent.errorMessage.apiError;
                // Adobe Analytics Starts
 this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'FAILURE', 'formResponse',
 'BC_Device_Signup_Review_Submit', 'API error', 'Failure_user', 'Submit', 'Body', '/businessconsole/signup/review');
                this.pageloaderService.setPageLoaderStatus(true);               
                this.utilityService.loadFocusOnTop();
              });
      } else {
              this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup, isNewProfile);
              // Adobe Analytics Starts
            this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formResponse',
            'BC_Device_Signup_Review_Submit', 'success', 'Success_Admit', 'Submit', 'Body', '/businessconsole/signup/confirm');
              // End
              this.pageloaderService.setPageLoaderStatus(true);
              this.router.navigate(['/signup/confirm']);
      }
    }
  }
}